import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { ProjectWrapper, LinkButton } from '../../GlobalStyles'
import { ViewAllProjects } from '../../components/ViewAllProjects'
import { Carousel } from '../../components/Carousel'
import { ImageLoader } from '../../components/ImageLoader'
import wave from '../../assets/white-wave.svg'

import image1 from '../../assets/plantgeek/plantgeek1.png'
import image2 from '../../assets/plantgeek/plantgeek2.png'
import image3 from '../../assets/plantgeek/plantgeek3.png'
import image4 from '../../assets/plantgeek/plantgeek4.png'
import image5 from '../../assets/plantgeek/plantgeek5.png'
import image6 from '../../assets/plantgeek/plantgeek6.png'
import image7 from '../../assets/plantgeek/plantgeek7.png'
import image8 from '../../assets/plantgeek/plantgeek8.png'
import image9 from '../../assets/plantgeek/plantgeek9.png'
import image10 from '../../assets/plantgeek/plantgeek10.png'
import mockups from '../../assets/plantgeek/plantgeek-mockups.png'

export const Plantgeek = () => {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const projectImages = [
    image1,
    image2,
    image3,
    image4,
    image5,
    image6,
    image7,
    image8,
    image9,
    image10,
  ]

  return (
    <ProjectWrapper>
      <div
        className='banner'
        style={{ background: 'linear-gradient(to right, #A4E17D, #95D190)' }}
      >
        <img src={wave} alt='decorative wave' />
      </div>

      <section className='description'>
        <h1 className='title'>[ <b>Plantgeek</b> ]</h1>
        <div className='summary'>
          <p className='type'>Full Stack Development, Web App</p>
          <p className='duration'>Solo Project • 2021 – 2022</p>
        </div>

        <div className='details'>
          <p>
            Plantgeek transforms manual plant-tracking spreadsheets into a scalable web platform.  
            Users browse a rich plant database, manage personal collections, and submit new entries  
            for community review.
          </p>

          <div className='mockups'>
            <ImageLoader src={mockups} alt='Plantgeek mockups' borderRadius='10px' />
          </div>

          <p>
            Authenticated users can edit profiles, curate owned or wishlist collections, and earn  
            collectible stickers for approved contributions. Admins oversee submissions, ensuring  
            data quality and community engagement.
          </p>
        </div>

        <div style={{ margin: '40px 0' }}>
          <Carousel images={projectImages} />
        </div>

        <div className='details'>
          <p>
            Built with React.js, React Query, and Ant Design on the frontend, and Node.js, Express,  
            MongoDB & TypeScript on the backend. Fully responsive design adapts seamlessly across  
            desktop, tablet, and mobile.
          </p>
          <p>
            Continued maintenance throughout 2022 included performance optimizations, feature  
            enhancements, and security hardening.
          </p>
        </div>

        <div className='details'>
          <p>
            Explore the demo or dive into the code:{' '}
            <Link to='/projects/plantgeek-app'>mobile companion</Link> and{' '}
            <Link
              to='https://github.com/v-prt/plantgeek'
              target='_blank'
              rel='noopener noreferrer'
            >
              GitHub
            </Link>.
          </p>
          <div className='buttons'>
            <LinkButton
              className='black'
              href='https://www.plantgeek.co'
              target='_blank'
              rel='noopener noreferrer'>
              View Live Site
            </LinkButton>
            <LinkButton
              className='white'
              href='https://youtu.be/JTIm2Gd30EI'
              target='_blank'
              rel='noopener noreferrer'
            >
              View Demo
            </LinkButton>
          </div>
        </div>
      </section>

      <ViewAllProjects />
    </ProjectWrapper>
  )
}
